export default "__VITE_ASSET__210794dc__"